import React, { useState, useContext } from "react";
import { TextField, Button, Container, Typography, Box, CircularProgress } from "@mui/material";
import AuthContext from "../../contexts/Islogin";
import Register from "./Register";



export default function LoginForm() {
  const { login, setLoginUser,fetchLoginUser ,url } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const authenticate = (username, password) => {
  return fetch(`${url}api/v1/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: username,
      password: password,
    }),
  })
    .then(async (response) => {
      if (!response.ok) return false;
      const data = await response.json();
      if (data.token) {
        console.log('data',data)
        localStorage.setItem("token", data.token);
        return true;
      }
      return false;
    })
    .catch((error) => {
      console.error("Login error:", error);
      return false;
    });
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
  
    if (await authenticate(username, password)) {
      login(); // تغییر isLogin به true
      localStorage.setItem("username", username);
      setLoginUser(username); // ست کردن اولیه (می‌تونه حذف بشه اگه دیگه مهم نیست)
      await fetchLoginUser(); // ✅ گرفتن اطلاعات یوزر و ذخیره در context
    } else {
      setError("Invalid username or password");
    }
  
    setLoading(false);
  };
  

  if (showRegister) {
    return <Register goBack={() => setShowRegister(false)} />;
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: 8,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Login
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: "100%", marginTop: 1 }}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          {error && (
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          )}
          <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
          <Button
            onClick={() => setShowRegister(true)}
            color="secondary"
            fullWidth
            style={{ marginTop: "10px" }}
          >
            حساب ندارم! ثبت‌نام
          </Button>
        </form>
      </Box>
    </Container>
  );
}
